import { type CatOrDog, petTypes } from '@joinfluffy/common';

export function getPetTypeByPetTypeValue(petTypeValue: CatOrDog | null) {
  return petTypes.find((petType) => petType.value === petTypeValue);
}
